import { Button, Card, Chip, Divider, Icons, Stack, styled, Tooltip, Typography } from '@healthinal/ui';
import { differenceInMilliseconds } from 'date-fns';
import { useState } from 'react';
import {
  TherapyConditionDto,
  TherapyConditionDtoTherapyCondition,
  TherapyDto,
} from '../../../../../api/generated/model';
import { getTherapyConditionStatusText } from '../../../../../utils/condition.ts';
import { AddConditionDialog } from './AddConditionDialog.tsx';
import { ConditionComplianceCardRow } from './ConditionComplianceCardRow.tsx';
import { SetConditionIntervalDialog } from './SetConditionIntervalDialog.tsx';

export function ConditionCard({
  condition,
  patientId,
  currentTherapy,
}: {
  condition?: TherapyConditionDto[] | null;
  patientId: string;
  currentTherapy: TherapyDto;
}) {
  const [isAddConditionDialogOpen, setIsAddConditionDialogOpen] = useState(false);
  const [isSetConditionIntervalDialogOpen, setIsSetConditionIntervalDialogOpen] = useState(false);
  return (
    <>
      <Card>
        <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
          <Stack gap={1}>
            <Typography level="title-lg">Befinden</Typography>
            {currentTherapy.conditionIntervalDays && (
              <Stack direction={'row'} gap={1}>
                <Chip onClick={() => setIsSetConditionIntervalDialogOpen(true)}>
                  {currentTherapy.conditionIntervalDays} Tage
                </Chip>
                <Typography level={'body-sm'}>Therapie Rückfrage Interval</Typography>
              </Stack>
            )}
          </Stack>
          {condition && condition?.length > 0 && (
            <Button color={'neutral'} onClick={() => setIsAddConditionDialogOpen(true)}>
              Befinden erfassen
            </Button>
          )}
        </Stack>

        <Divider />
        {condition?.length ? (
          <Stack gap={2}>
            {[...condition]
              .sort((a, b) => differenceInMilliseconds(b.date, a.date))
              .map((condition) => (
                <ConditionComplianceCardRow
                  key={condition.id ?? condition.date}
                  // showDanger={
                  //   condition.therapyCondition === TherapyConditionDtoTherapyCondition.BAD_NORMAL_WORK ||
                  //   condition.therapyCondition === TherapyConditionDtoTherapyCondition.BAD_PART_TIME_WORK ||
                  //   condition.therapyCondition === TherapyConditionDtoTherapyCondition.BAD_NO_WORK
                  // }
                  date={condition.date}
                  createdBy={condition.createdBy}
                  status={condition.therapyCondition}
                />
              ))}
          </Stack>
        ) : (
          <Stack alignItems={'center'} gap={1} p={3}>
            <Icons.Description />
            <Typography level="body-sm">Noch kein Befinden vorhanden.</Typography>
            <Tooltip
              disableHoverListener={currentTherapy.id !== undefined}
              title={'Um ein Befinden erfassen zu können muss eine Therapie vorhanden sein.'}>
              <StyledButton
                variant={!currentTherapy ? 'soft' : 'solid'}
                color={!currentTherapy ? 'neutral' : 'primary'}
                sx={!currentTherapy ? { cursor: 'default' } : { cursor: 'pointer' }}
                onClick={() =>
                  currentTherapy &&
                  (currentTherapy.conditionIntervalDays
                    ? setIsAddConditionDialogOpen(true)
                    : setIsSetConditionIntervalDialogOpen(true))
                }>
                Befinden erfassen
              </StyledButton>
            </Tooltip>
          </Stack>
        )}
      </Card>
      <SetConditionIntervalDialog
        open={isSetConditionIntervalDialogOpen}
        onClose={() => setIsSetConditionIntervalDialogOpen(false)}
        currentTherapy={currentTherapy}
      />
      <AddConditionDialog
        open={isAddConditionDialogOpen}
        onClose={() => setIsAddConditionDialogOpen(false)}
        patientId={patientId}
        therapyId={currentTherapy.id!}
      />
    </>
  );
}

const StyledButton = styled(Button)(({ theme }) => ({
  '--variant-softHoverBg': theme.palette.neutral.softBg,
  '--variant-softActiveBg': theme.palette.neutral.softBg,
  '--variant-softActiveColor': theme.palette.neutral.softColor,
}));
